import HeaderContent from "@shared/ui/header-content/header-content";
import { Menubar } from "primereact/menubar";
import { FaChevronLeft } from "react-icons/fa";
import { Outlet, useNavigate } from "react-router-dom";

import useQuotationUtils from "./quotation-utils-shell.hook";

export function QuotationUtilsShell() {
  const { items } = useQuotationUtils();
  const navigate = useNavigate();
  return (
    <div id="ShellQuotationUtils" className="">
      <HeaderContent
        title={<h1>Quotation Utilities</h1>}
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      ></HeaderContent>
      <div className="p-7">
        <Menubar model={items} />
        <Outlet />
      </div>
    </div>
  );
}

export default QuotationUtilsShell;
